export const loadStageVisual = (listItem) => {
	const stageVisual = listItem.querySelector('.sub--stage .sub__visual');

	if (stageVisual) {
		const visualUrl = stageVisual.getAttribute('data-image-url');
		if (!stageVisual.style.background && visualUrl) {
			stageVisual.style.backgroundImage = `url(${visualUrl})`;
			stageVisual.removeAttribute('data-image-url');
		}
	}
};
